"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const immutable_1 = require("immutable");
const SupportingCreativeFormatPlacement_1 = require("./SupportingCreativeFormatPlacement");
class SupportingCreativeFormatNetwork {
    constructor({ id, key, name, placements, }) {
        this.toJSON = () => ({
            id: this.id,
            key: this.key,
            name: this.name,
            placements: this.placements.toJSON(),
        });
        this.id = id;
        this.key = key;
        this.name = name;
        this.placements = placements;
    }
}
SupportingCreativeFormatNetwork.fromJSON = (json) => {
    const { id, key, name, placements } = Object.assign({}, json);
    if (typeof id !== 'string')
        throw new Error('.id must be a string');
    if (typeof key !== 'string')
        throw new Error('.key must be a string');
    if (typeof name !== 'string')
        throw new Error('.name must be a string');
    if (!Array.isArray(placements))
        throw new Error('.placements must be an array');
    switch (key) {
        case 'facebook':
        case 'instagram':
        case 'snapchat':
        case 'youtube':
        case 'twitter':
        case 'line':
        case 'yahoo':
        case 'google':
        case 'apple':
        case 'amazon':
        case 'owned_media':
        case 'other':
        case 'any_network':
            // OK
            break;
        default:
            throw new Error(`A creative network key "${key}" is not valid.`);
    }
    return new SupportingCreativeFormatNetwork({
        id,
        key,
        name,
        placements: immutable_1.List(placements).map(item => SupportingCreativeFormatPlacement_1.default.fromJSON(item)),
    });
};
exports.default = SupportingCreativeFormatNetwork;
